<template>
  <b-form @submit.prevent="submitForm" class="col-sm-12 forgot-form">
    <b-form-group v-for="form in formBasicData" :key="form.tmpId" class="text-capitalize mt-3" :invalid-feedback="
                      renderInvalidFeedback({
                        validationDesc: form['validation-desc']
                      })
                    " :state="renderError({ error: form.error })">
      <b-input-group>
        <b-input-group-text slot="append" @click="switchVisibility(form)">
          <font-awesome-icon v-if="form.visible == false" icon="eye"  />
          <font-awesome-icon v-else icon="eye-slash"  />
        </b-input-group-text>
        <b-form-input :type="form.type || 'text'" :value="form.value" @keyup="
                setValue({
                  rawLabel: form.rawLabel,
                  label: form.label,
                  $event,
                  tmpId: form.tmpId
                })
              " size="lg" v-bind:maxlength="form.maxlength" class="border-right-0"
          :state="renderError({ error: form.error })" :placeholder="form.placeholder" />
      </b-input-group>
    </b-form-group>
    <button class="btn d-block shadow-none w-100 btn-lg "
      style="background-color :#3F7EA7; color:white; border-radius : 10px;margin-top:20px" type="submit">
      <span class="btn-wrapper--label text-capitalize">
        Atur Kata Sandi
      </span>
    </button>
  </b-form>
</template>

<script>
  import startCase from "lodash/startCase";
  import {
    required,
    minLength,
    maxLength,
    sameAs
  } from "vuelidate/lib/validators";
  import axios from 'axios';

  import {
    library
  } from "@fortawesome/fontawesome-svg-core";
  import {
    faEye,
    faEyeSlash,
    faInfo
  } from "@fortawesome/free-solid-svg-icons";

  library.add(
    faEye,
    faInfo,
    faEyeSlash
  );

  export default {
    name: "SetPasswordForm",
    props: ['token'],
    data: () => ({
      formBasicData: null,
      formData: null,
    }),
    validations: {
      formData: {
        kata_sandi: {
          required,
          maxLength: maxLength(15),
          verifyPassword(val) {
            if (val && val.match(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}$/)) {
              return true
            } else {
              return false;
            }
          }
        },
        konfirmasi_ulang_kata_sandi: {
          required,
          sameAsPassword: sameAs("kata_sandi"),
          minLength: minLength(6),
          maxLength: maxLength(15)
        }
      }
    },
    mounted() {
      this.formData = this.setFormData();
      this.formBasicData = this.setFormBasicData();
    },
    methods: {
      switchVisibility(form) {
        form.visible = !form.visible;
        if(form.visible) {
          form.type = 'text';
        }
        else {
          form.type = 'password';
        }
      },
      setFormData() {
        return this.setFormBasicData().reduce((arr, val) => {
          arr[val.label.split(" ").join("_")] = null;
          return arr;
        }, {});
      },
      setFormBasicData() {
        const tmp = [{
            label: "kata sandi",
            placeholder: "kata sandi",
            type: "password",
            maxlength: 15,
            visible: false
          },
          {
            label: "konfirmasi ulang kata sandi",
            placeholder: "Konfirmasi ulang kata sandi",
            type: "password",
            maxlength: 15,
            visible: false
          }
        ];

        return tmp.map((item, index) => ({
          ...item,
          label: item.label.split(" ").join("_"),
          tmpId: index,
          error: null,
          placeholder: startCase(item.placeholder),
          rawLabel: item.label
        }));
      },
      setValue({
        label,
        rawLabel,
        $event = null
      } = {}) {
        const {
          target
        } = $event;
        const {
          value
        } = target;
        const $v_object = this.$v.formData[label];
        this.formData[label] = value && value.trim();

        this.formBasicData.forEach((item) => {
          this.triggerValidation({
            label: item.label,
            $v: this.$v,
            $vm: this,
            rawLabel: item.rawLabel
          });
        })
      },
      async resetPassword() {
        try {
          const res = await axios.post(`${this.url_api}/activate_password/${this.token}`, {
            password: this.formData.kata_sandi,
            password_confirmation: this.formData.konfirmasi_ulang_kata_sandi
          });
          const {
            status,
            message
          } = res.data;
          if (status) {
            this.$swal({
              type: "success",
              title: "Selamat!",
              text: "Pendaftaran akun izidok Anda berhasil. Segera jelajahi fitur lengkap izidok dan daftarkan pasien pertama Anda!",
              allowOutsideClick: false,
              confirmButtonText: 'Login'
            }).then((e) => {
              if (e.value) {
                this.$router.push('/login')
              }
            });
          } else if(message == 'Token has expired!') {
            this.$swal({
              type: "error",
              title: "Tautan sudah kedaluwarsa",
              text: "Silakan hubungi tim Izidok untuk aktivasi ulang!"
            }).then((e) => {
              this.$router.push('/login');
            });
          } else {
            this.$swal({
              type: "error",
              title: "Gagal atur kata sandi",
              html: `${message}<br>Silakan hubungi tim Izidok`
            }).then((e) => {
              this.$router.push('/login');
            });
          }
        } catch (err) {
          // console.log(err);
        }
      },
      submitForm($event) {
        const {
          formBasicData
        } = this;
        if (formBasicData.every(item => item.error !== null && !item.error)) {
          this.resetPassword();
        } else {
          formBasicData.map(item => {
            this.triggerValidation({
              label: item.label,
              $v: this.$v,
              $vm: this,
              rawLabel: item.rawLabel
            });
          });
        }
      }
    }
  };
</script>

<style>
  .forgot-form .invalid-feedback {
    color: red !important;
  }
</style>